import { render, staticRenderFns } from "./ParsingGroupPage.vue?vue&type=template&id=24c6082a&scoped=true"
import script from "./ParsingGroupPage.vue?vue&type=script&lang=js"
export * from "./ParsingGroupPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c6082a",
  null
  
)

export default component.exports